import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private renderer: Renderer2;
  private themeKey = 'preferred-theme';

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  initTheme(): void {
    const savedTheme = (localStorage.getItem(this.themeKey) as 'light' | 'dark') || 'light';
    this.applyTheme(savedTheme);
  }

  toggleTheme(): void {
    const currentTheme = document.documentElement.getAttribute('data-bs-theme') as 'light' | 'dark';
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
    this.applyTheme(newTheme);
  }

  applyTheme(theme: 'light' | 'dark'): void {
    this.renderer.setAttribute(document.documentElement, 'data-bs-theme', theme);
    this.renderer.setAttribute(document.documentElement, 'data-menu-color', theme);
    localStorage.setItem(this.themeKey, theme);
  }

  getCurrentTheme(): 'light' | 'dark' {
    return (localStorage.getItem(this.themeKey) as 'light' | 'dark') || 'light';
  }
}
